'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TONE } from '../system/tone';
export function Thumbnail({ src, tone = 'neutral', size = 44, radius = 'var(--radius-md)', children, style, }) {
    const [errored, setErrored] = useState(false);
    // Reset error state when src changes so a new url gets a fresh load attempt.
    useEffect(() => {
        setErrored(false);
    }, [src]);
    // The image is a real <img> (not a CSS background) so the browser can
    // lazy-load and async-decode thumbnails in long list rows. It layers on
    // top of the tone background; a broken / 404'd URL falls back to the tone.
    const t = TONE[tone];
    const showImage = src !== undefined && !errored;
    return (_jsxs("div", { style: {
            width: size,
            height: size,
            borderRadius: radius,
            flexShrink: 0,
            background: t.bg,
            color: t.ink,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...style,
        }, children: [showImage && (_jsx("img", { src: src, alt: "", loading: "lazy", decoding: "async", draggable: false, onError: () => setErrored(true), style: {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                } })), children != null && (
            // Positioned so glyph children paint above the absolutely-positioned img.
            _jsx("div", { style: { position: 'relative', display: 'flex' }, children: children }))] }));
}
//# sourceMappingURL=Thumbnail.js.map